import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { HttpWrapperService } from '.././http-wrapper.service';
import { IHttpRequestOptions } from '../../interfaces/http-request-option.interface';
import { PagedResult } from '../../interfaces/IPagingResponseModel.interface';
import { IPagingRequestModel } from '../../interfaces/IPagingRequestModel.interface';
import { HttpHeaders } from '@angular/common/http';
import { IUser, UserRequestDto } from '../../interfaces/user.interface';
import { CommunityDisbursementModel } from '../../interfaces/Disbursment.interface';


@Injectable({
  providedIn: 'root'
})
export class ManageUserService {
  constructor(private httpWrapperService: HttpWrapperService) { }

  getManageUsers(
    communityId: number,
    request: IPagingRequestModel,
  ): Observable<PagedResult<IUser>> {
    const url = `user/list/${communityId}`;
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const params: { [key: string]: string } = {};

    const options: IHttpRequestOptions = {
      url: url,
      headers: headers,
      body: request,
      params: params
    };
    return this.httpWrapperService.postFromApiGateWay(options).pipe(
      map((response: PagedResult<IUser>) => response)
    );
  }

  createUser(user: UserRequestDto): Observable<IUser> {
    const url = `user`;
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const options: IHttpRequestOptions = {
      url: url,
      headers: headers,
      body: user,
    };
    return this.httpWrapperService.postFromApiGateWay(options).pipe(
      map((response: IUser) => response)
    );
  }

  linkUserToCommunity(id: number, communityId: number): Observable<boolean> {
    const url = `linkedUserCommunity`;
    const requestBody = {
      communityID: communityId,
      UserIds: [id]
    };
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const options: IHttpRequestOptions = {
      url: url,
      body: requestBody,
      headers: headers,
    };
    return this.httpWrapperService.postFromApiGateWay(options).pipe(
      map((response: boolean) => response)
    );
  }

  sendUserInvitationEmail(email:string, communityName: string): Observable<boolean> {
    const url = `UserInvite`;
    const requestBody = {
      email: email,
      communityName: communityName
    };
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const options: IHttpRequestOptions = {
      url: url,
      body: requestBody,
      headers: headers,
    };
    return this.httpWrapperService.postFromApiGateWay(options).pipe(
      map((response: boolean) => response)
    );
  }


  editUser(userID: number, user: IUser): Observable<IUser> {
    const url = `user/${userID}`;
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const options: IHttpRequestOptions = {
      url: url,
      headers: headers,
      body: user,
    };
    return this.httpWrapperService.putFromApiGateWay(options).pipe(
      map((response: IUser) => response)
    );
  }

  activateUser(userId: number): Observable<number> {
    const url = `user/update-user-access/${userId}`;
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const options: IHttpRequestOptions = {
      url: url,
      headers: headers,
    };
    return this.httpWrapperService.putFromApiGateWay(options).pipe(
      map((response: number) => response)
    );
  }

  exportFilteredDataToCsv(communityId: number): Observable<Blob> {
    const url = `user/export/${communityId}`;
    const headers = new HttpHeaders().set('Content-Type', 'text/csv');
    const options: IHttpRequestOptions = {
      url: url,
      headers: headers,
      responseType: 'blob'
    };
    return this.httpWrapperService.postFromApiGateWay(options).pipe(
      map((response: Blob) => response)
    );

  }

  getUserByEmailId(
    email: string,
  ): Observable<IUser> {
    const url = `user/email`;
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    const options: IHttpRequestOptions = {
      url: url,
      headers: headers,
      params: { email: email }
    };
    return this.httpWrapperService.getFromApiGateWay(options).pipe(
      map((response: IUser) => response)
    );
  }
  getDisbursementAccount(id: number): Observable<CommunityDisbursementModel[]> {
    const url = `CommunityDisbursement/${id}`;
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const options: IHttpRequestOptions = {
      url: url,
      headers: headers,
    };
    return this.httpWrapperService.getFromApiGateWay(options).pipe(
      map((response: CommunityDisbursementModel[]) => response)
    );
  }
  getUser(userID: number): Observable<IUser> {
    const url = `user/${userID}`;
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const options = { url, headers };
   
    return this.httpWrapperService.getFromApiGateWay(options).pipe(
      map((response: IUser) => response)
    );
  }

  addAuth0Log(userId: number, ipAddress: string, loginDateTime?: Date): Observable<string> {
    const url = `auth0`;
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const options: IHttpRequestOptions = {
      url: url,
      headers: headers,
      body: { userId: userId, loginDateTime: loginDateTime, ipAddress: ipAddress },
    };
    return this.httpWrapperService.postFromApiGateWay(options).pipe(
      map((response: string) => response));
  }
  
  validateUserToAdd(
    communityId: number,
    email: string,
  ): Observable<string> {
    const url = `ValidateUserCommunity`;
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    const options: IHttpRequestOptions = {
        url: url,
        headers: headers,
        body: {
          communityId: communityId,
          emailAddress: email
        }
      };
    return this.httpWrapperService.postFromApiGateWay(options).pipe(
        map((response: string) => response)
    );
  }

  reactivateUserAuth0(email: string): Observable<boolean> {
    const url = `auth0/reactivate`;
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const options: IHttpRequestOptions = {
      url: url,
      headers: headers,
      params: { email: email }
    };
    return this.httpWrapperService.putFromApiGateWay(options).pipe(
      map((response: boolean) => response)
    );
  }

  deactivateUserAuth0(email: string): Observable<boolean> {
    const url = `auth0/deactivate`;
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const options: IHttpRequestOptions = {
      url: url,
      headers: headers,
      params: { email: email }
    };
    return this.httpWrapperService.putFromApiGateWay(options).pipe(
      map((response: boolean) => response)
    );
  }
}
